<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增主级
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" :pagination="false" :scroll="{y:'70vh'}" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a @click="addMenuChildren(row)">新增下级</a>
                <a style="padding-left:5px;" @click="editMenus(row)">编辑</a>
                <a style="padding-left:5px;color:red" @click="deleteMenu(row)">{{row.state==='1'?'启用':'禁用'}}</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible" title="菜单管理" ok-text="确定" cancel-text="取消" @ok="addMenu" @cancel="resetForm">
            <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
                <a-form-model-item label="序号">
                    <a-input-number style="width: 100%" v-model="form.orderNo"/>
                </a-form-model-item>
                <a-form-model-item label="菜单名称">
                    <a-input v-model="form.name"/>
                </a-form-model-item>
                <a-form-model-item label="菜单图标">
                    <a-input v-model="form.icon"/>
                </a-form-model-item>
                <a-form-model-item label="菜单路由">
                    <a-input v-model="form.router"/>
                </a-form-model-item>
                <a-form-model-item label="菜单URL">
                    <a-input v-model="form.url"/>
                </a-form-model-item>
                <a-form-model-item label="菜单描述">
                    <a-input v-model="form.descpt"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import {getMenuList, editMenu} from './js/ApiRole'

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '菜单名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '菜单前图标',
            dataIndex: 'icon',
            key: 'icon',
            ellipsis: true,
        },
        {
            title: '菜单路由',
            dataIndex: 'router',
            key: 'router',
            ellipsis: true,
        },
        {
            title: '菜单Url',
            dataIndex: 'url',
            key: 'url',
            ellipsis: true,
        },
        {
            title: '菜单描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
        },
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                visible: false,
                form: {
                    orderNo: '',
                    parentId: '0',
                    name: '',
                    icon: '',
                    router: '',
                    url: '',
                    descpt: ''
                }
            }
        },
        methods: {
            //新增
            addMenu() {
                this.form.orderNo = this.form.orderNo + '';
                editMenu(this.form).then(() => {
                    this.visible = false;
                    getMenuList({}).then(res => {
                        this.data = res.data;
                    })
                })
            },
            editMenus(row) {
                this.form = row;
                this.visible = true
            },
            //新增子级
            addMenuChildren(row) {
                this.form.parentId = row.id;
                this.visible = true
            },
            //删除
            deleteMenu(row) {
                row.state = '1';
                editMenu(row).then(() => {
                    getMenuList({}).then(res => {
                        this.data = res.data;
                        this.visible = false
                    })
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    parentId: '0',
                    name: '',
                    icon: '',
                    router: '',
                    url: '',
                    descpt: ''
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getMenuList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            getMenuList({}).then(res => {
                this.data = res.data;
                console.log(res)
            })
        }
    }
</script>

<style scoped>
</style>
